import axios from "axios";
import { toast } from "react-toastify";
import { env } from ".env";

class ApiHandlersModel {
  constructor() {
    this.refreshError = false;
  }

  async createApiCall(requestObj) {
    const {
      method = "get",
      url,
      reqObj = null,
      params = null,
      contentType = "application/json",
      responseType = null,
    } = requestObj;

    const token = localStorage.getItem("token");

    const defaultReqObj = {
      method,
      url: `${env.REACT_APP_BASE_URL}${url}`,
      responseType,
      headers: {
        accept: "application/json",
        "Content-Type": contentType,
        Authorization: token,
      },
      params,
    };

    const reqObjWithBody = { ...defaultReqObj, data: reqObj };

    return await axios(!reqObj ? defaultReqObj : reqObjWithBody);
  }

  async response(request) {
    try {
      const response = await this.createApiCall(request);

      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 202
      ) {
        if (response.data) {
          return { type: true, data: response.data };
        } else {
          return {
            type: false,
            message: "خطا در بر قراری ارتباط با سرور",
            status: response.status,
          };
        }
      }
    } catch (error) {
      return this.fail(error);
    }
  }

  async fail(e) {
    if (e?.response?.status === 403 || e?.response?.status === 401) {
      const refreshToken = localStorage.getItem("refreshToken");

      if (refreshToken) {
        const apiObj = {
          url: "api/users/refresh",
          method: "post",
          reqObj: { refreshToken: refreshToken },
        };
        if (!this.refreshError) {
          this.refreshError = true;
          const refreshResponse = await this.response(apiObj);
          if (refreshResponse.type) {
            localStorage.setItem("token", refreshResponse.data.data.token);
            window.location.reload();
          } else {
            window.location.href = "/login";
            localStorage.clear();
          }
        }
      } else {
        window.location.href = "/login";
        localStorage.clear();
      }
    }
    if (e?.response?.status === 429) {
      toast.error(e?.response?.data?.data);
      toast.warning("لطفا بعد از چند دقیقه دوباره تلاش کنید.");
    }

    let message = "";

    if (!e?.response?.status >= 500) {
      message = "خطا در بر قراری ارتباط با سرور";
    } else {
      message = e?.response?.data?.data;
    }

    return {
      type: false,
      message: message,
      status: e.response && e.response.status ? e.response.status : null,
    };
  }

  async vpn({ url }) {
    return await axios({
      url: `${env.REACT_APP_VPN_URL}${url}`,
      method: "get",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }
}

const requestModel = new ApiHandlersModel();

export default requestModel;
